import React from 'react'
import { ActionsDropdown } from '@/components/dropdowns/ActionsDropdown'

export const PlaybookEntryActions = ({
  isWinnable,
  isRetiredNotificationType,
  readOnly,
  handleEdit,
  handleWin,
  handleDelete,
  entry,
}) => {
  if (readOnly) {
    return null
  }

  const handleWinMarker = (event) => {
    event.stopPropagation()

    handleWin()
  }

  const actions = []

  if (handleEdit) {
    actions.push({
      label: readOnly || isRetiredNotificationType ? 'View Item' : 'Edit Item',
      onClick: handleEdit,
      testId: 'edit-option',
    })
  }

  if (isWinnable) {
    actions.push({
      label: entry.win ? 'Remove Win Marker' : 'Mark as Win',
      onClick: handleWinMarker,
      testId: 'win-option',
    })
  }

  actions.push({
    label: 'Delete Item',
    onClick: handleDelete,
    testId: 'delete-option',
    isDanger: true,
  })

  return (
    <div className="playbook-entry__actions">
      <ActionsDropdown
        buttonProps={{ basic: true }}
        actions={actions}
        dataTestId="playbook-entry-actions-dropdown"
      />
    </div>
  )
}
